import React from 'react'
import { Link } from 'react-router-dom'
import "./foot.css"

export const Foot = () => {
  return (
    <div className='foot'>
      <div className="top"><input type="text" value= ' Disabled' disabled/><button>Search</button></div>
      <div className="mid"><span><Link to="g.g">Nairaland</Link></span> - Copywrite &copy; 2005 - 2022 &nbsp;<Link to="g.g"> Oluwaseun Osewa</Link>. All rights reserved. See &nbsp; <Link to="g.g"> How To Advertise</Link>. 1</div>
      <div className="bottom"><span>Disclaimer</span>: Every Nairaland member is <span>&nbsp;solely responsible&nbsp;</span> for <span>&nbsp;anything&nbsp;</span> that he or she <span>&nbsp;posts&nbsp; </span>or <span>&nbsp;uploads&nbsp; </span> on Nairaland.</div>
      <h4 className="owner">Built and Designed by Olawale @ <a href="snotat.com">snotat.com</a> </h4>
    </div>
  )
}
